export default __webpack_public_path__ + "static/media/tidy_avatar_4.3019c227.png";